module.exports = __webpack_public_path__ + "img/music-test-icon1.09eb2292.png";